var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_3509",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_3509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 17.3333V14.6666H29.3337V17.3333H24.0003ZM25.6003 26.6666L21.3337 23.4666L22.9337 21.3333L27.2003 24.5333L25.6003 26.6666ZM22.9337 10.6666L21.3337 8.53331L25.6003 5.33331L27.2003 7.46665L22.9337 10.6666ZM6.66699 25.3333V20H5.33366C4.60033 20 3.97255 19.7389 3.45033 19.2166C2.9281 18.6944 2.66699 18.0666 2.66699 17.3333V14.6666C2.66699 13.9333 2.9281 13.3055 3.45033 12.7833C3.97255 12.2611 4.60033 12 5.33366 12H10.667L17.3337 7.99998V24L10.667 20H9.33366V25.3333H6.66699ZM14.667 19.2666V12.7333L11.4003 14.6666H5.33366V17.3333H11.4003L14.667 19.2666ZM18.667 20.4666V11.5333C19.267 12.0666 19.7503 12.7166 20.117 13.4833C20.4837 14.25 20.667 15.0889 20.667 16C20.667 16.9111 20.4837 17.75 20.117 18.5166C19.7503 19.2833 19.267 19.9333 18.667 20.4666Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.75dfd121b3ffc424b7bb0ce5483049af.svg";
export { ForwardRef as ReactComponent };